import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/common';
import { Radio } from 'antd';

import { withTranslation } from 'language/i18n';

const MobileActions = ({
  t, setMobileFilterVisible, getDefaultSortValue, onFilter,
}) => {
  const [menuVisible, setMenuVisible] = useState(false);

  return (
    <>
      <div className="row d-lg-none">
        <div className="col">
          <Button
            className="im-button im-button--less-gutter im-button--white2 im-button--fluid im-button--center im-button--size-40 p-relative js-Actions-open"
            onClick={() => setMobileFilterVisible(true)}
          >
            <div className="im-button__icon im-button__icon--left">
              <i className="fa-solid fa-filter fs-15" />
            </div>
            <span className="fs-13 fw-400">
              {t('filter')}
            </span>
            <div className="dot-indicator" />
          </Button>
        </div>
        <div className="col">
          <Button
            className="im-button im-button--less-gutter im-button--white2 im-button--fluid im-button--center im-button--size-40 p-relative js-sort-open"
            onClick={() => setMenuVisible(true)}
          >
            <div className="im-button__icon im-button__icon--left">
              <i className="fa-solid fa-sort fs-15" />
            </div>
            <span className="fs-13 fw-400">{t('sort')}</span>
            <div className="dot-indicator" />
          </Button>
        </div>
      </div>
      <div className={`mobile-sort-menu ${menuVisible && 'mobile-sort-menu--active'}`}>
        <div
          className="im-box im-box--white im-box--fluid im-box--border-radius im-box--padding-0 im-box--fluid d-flex flex-column"
        >
          <div id="sortForm" className="h-100 w-100 d-flex flex-column">
            <div className="fs-17 fw-700 p-20">{t('sortBy')}</div>
            <div className="separator separator--horizontal" />
            <Radio.Group
              style={{
                flexDirection: 'column', display: 'flex', padding: '20px', paddingTop: '5px',
              }}
              onChange={(event) => onFilter({ name: 'sort', value: event.target.value })}
              value={getDefaultSortValue()}
              name="sort"
            >
              <Radio value="az"><span className="im-checkbox__text">A-Z</span></Radio>
              <Radio value="za"><span className="im-checkbox__text">Z-A</span></Radio>
              <Radio value="cheapToExpensive"><span className="im-checkbox__text">Fiyata Göre Artan</span></Radio>
              <Radio value="expensiveToCheap"><span className="im-checkbox__text">Fiyata Göre Azalan</span></Radio>
              <Radio value="eventFarToEndDate"><span className="im-checkbox__text">Bitiş Tarihi En Uzak</span></Radio>
              <Radio value="eventCloseToEndDate"><span className="im-checkbox__text">Bitiş Tarihi En Yakın</span></Radio>
              <Radio value="youngToOld">
                <span className="im-checkbox__text">Yeniden Eskiye</span>
              </Radio>
              <Radio value="oldToYoung">
                <span className="im-checkbox__text"> Eskiden Yeniye</span>
              </Radio>
            </Radio.Group>
            <div className="separator separator--horizontal" />
          </div>
          <div className="mobile-sort-menu__actions">
            <button
              type="button"
              className="im-button im-button--primary im-button--fluid im-button--center"
              onClick={() => setMenuVisible(false)}
            >
              Uygula
            </button>
          </div>
        </div>
      </div>
      {/* <!-- mobile sort close --> */}
      <i className="fa-solid fa-times mobile-menu-overflow-close js-sort-close" onClick={() => setMenuVisible(false)} />
    </>
  );
};

MobileActions.propTypes = {
  t: PropTypes.func,
  setMobileFilterVisible: PropTypes.func,
  getDefaultSortValue: PropTypes.func,
  onFilter: PropTypes.func,
};

export default withTranslation('common')(MobileActions);
